import React, { useState, useEffect, useRef } from "react";
import useStyles from "./styles";
import LoadingIcon from "../../assets/img/icons/loaderIcon.gif";
import LoadingIconFiggers from "../../assets/img/icons/loaderfiggers.gif";

export default function Loader() {
    const classes = useStyles();
    return (
        <>
            <div className={classes.fixloader}>
                <img src={LoadingIconFiggers} />
            </div>
        </>
    )
}
